<style scoped>
	.layout{
    border: 1px solid #d7dde4;
    background: #f5f7f9;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
}
.layout-logo{
    width: 150px;
    height: 50px;
    border-radius: 3px;
    float: left;
    position: relative;
		color: #fff;
		font-size: 24px;
		text-align: center;
		line-height: 50px;
		top: 6px;
}
.layout-nav{
    width: 420px;
    margin: 0 auto;
    margin-right: 20px;
}
.layout-footer-center{
    text-align: center;
}
</style>
<template>
	<div class="layout">
		<Layout>
			<Header :style="{position: 'fixed', width: '100%','z-index':999}">
				<Menu mode="horizontal" theme="dark" active-name="1">
					<div class="layout-logo">车检宝管理端</div>
					<div class="layout-nav">
					</div>
				</Menu>
			</Header>
			<Layout :style="{padding: '0'}">
				<Content :style="{padding: '64px 0', minHeight: '100%', background: '#f5f5f5'}">
					<Layout>
						<Sider hide-trigger :style="{position: 'fixed', height: '100vh', left: 0, overflow: 'auto'}">
							<Menu :active-name="$route.meta.menu" theme="light" width="auto" :open-names="$route.meta.nav" accordion>
								<Submenu name="1" v-if="purview.client">
									<template slot="title">
										<Icon type="ios-navigate"></Icon>
										客户端管理
									</template>
									<MenuItem name="1-1" to="/client/config" v-if="purview.client.indexOf('1001')>=0">
									<Icon type="md-arrow-dropright" /> 小程序配置</MenuItem>
									<MenuItem name="1-2" to="/client/user/list" v-if="purview.client.indexOf('1002')>=0">
									<Icon type="md-arrow-dropright" /> 会员管理</MenuItem>
									<MenuItem name="1-5" to="/client/score/index" v-if="purview.client.indexOf('1003')>=0">
									<Icon type="md-arrow-dropright" /> 积分管理</MenuItem>
									<MenuItem name="1-3" to="/client/tg/list" v-if="purview.client.indexOf('1004')>=0">
									<Icon type="md-arrow-dropright" /> 推广管理</MenuItem>
									<Submenu name="1-4" v-if="purview.client.indexOf('1005')>=0">
										<template slot="title">
											<Icon type="ios-navigate"></Icon>
											提现管理
										</template>
										<MenuItem name="1-4-1" to="/client/tx/list">
										<Icon type="md-arrow-dropright" /> 提现申请</MenuItem>
										<MenuItem name="1-4-2" to="/client/tx/setting">
										<Icon type="md-arrow-dropright" /> 提现设置</MenuItem>
									</Submenu>
									<MenuItem name="1-6" to="/client/page/list" v-if="purview.client.indexOf('1006')>=0">
									<Icon type="md-arrow-dropright" /> 页面管理</MenuItem>
									<Submenu name="1-7" v-if="purview.client.indexOf('1007')>=0">
										<template slot="title">
											<Icon type="ios-ribbon-outline"></Icon>
											活动管理
										</template>
										<Submenu name="1-7-1" v-if="purview.client.indexOf('1007')>=0">
											<template slot="title">
												<Icon type="ios-bookmark-outline" />
												1元抢券
											</template>
											<MenuItem name="1-7-1-1" to="/client/activity/coupon/setting">
											<Icon type="md-arrow-dropright" /> 活动设置</MenuItem>
											<MenuItem name="1-7-1-2" to="/client/activity/coupon/log/list">
											<Icon type="md-arrow-dropright" /> 抢券记录</MenuItem>
										</Submenu>
									</Submenu>
									<!--
								-->
								</Submenu>
								<Submenu name="2" v-if="purview.sf">
									<template slot="title">
										<Icon type="ios-keypad"></Icon>
										服务师傅端管理
									</template>
									<MenuItem name="2-1" to="/sf/config" v-if="purview.sf.indexOf('2001')>=0">
									<Icon type="md-arrow-dropright" /> 小程序配置</MenuItem>
									<MenuItem name="2-2" to="/sf/user/list" v-if="purview.sf.indexOf('2002')>=0">
									<Icon type="md-arrow-dropright" /> 师傅管理</MenuItem>
									<!-- <MenuItem name="2-3" to="/dz/bank/list"><Icon type="md-arrow-dropright" /> 银行卡</MenuItem> -->
								</Submenu>
								<Submenu name="3" v-if="purview.order">
									<template slot="title">
										<Icon type="ios-keypad"></Icon>
										订单管理
									</template>
									<MenuItem name="3-1" to="/order/setting" v-if="purview.order.indexOf('3001')>=0">
									<Icon type="md-arrow-dropright" /> 订单设置</MenuItem>
									<MenuItem name="3-2" to="/order/list" v-if="purview.order.indexOf('3002')>=0">
									<Icon type="md-arrow-dropright" /> 订单管理</MenuItem>
									<!--<MenuItem name="3-3" to="/order/rate/list"><Icon type="md-arrow-dropright" /> 评价管理</MenuItem>-->
									<MenuItem name="3-4" to="/order/coupon" v-if="purview.order.indexOf('3004')>=0">
									<Icon type="md-arrow-dropright" /> 优惠券管理</MenuItem>
								</Submenu>
								<Submenu name="4" v-if="purview.public">
									<template slot="title">
										<Icon type="ios-keypad"></Icon>
										公共信息管理
									</template>
									<MenuItem name="4-1" to="/public/jcz/list" v-if="purview.public.indexOf('4001')>=0">
									<Icon type="md-arrow-dropright" /> 检测站管理</MenuItem>
								</Submenu>
								<Submenu name="5" v-if="purview.admin">
									<template slot="title">
										<Icon type="ios-keypad"></Icon>
										管理员管理
									</template>
									<MenuItem name="5-1" to="/admin/user/list" v-if="purview.admin.indexOf('5001')>=0">
									<Icon type="md-arrow-dropright" /> 管理员管理</MenuItem>
								</Submenu>
							</Menu>
						</Sider>
						<Content :style="{padding: '24px', minHeight: '100%', background: '#f5f5f5', marginLeft:'200px'}">
							<router-view style="padding: 24px;">
							</router-view>
						</Content>
					</Layout>
				</Content>
			</Layout>
		</Layout>
		<Spin fix v-if="loading">
			<Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
			<div>处理中...</div>
		</Spin>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				loading: false,
				purview: {}
			};
		},
		created() {
			this.loading = true;
			this.$http.post('/server/api/index.php?a=init').then(
				res => {
					if (res.data.result == 'ok') {
						//this.$Message.success('获取成功!');
						this.purview = res.data.data;
						this.loading = false;
					} else {
						this.$Message.error(res.data.msg);
					}
				},
				r => {
					this.loading = false;
					this.$Message.error('系统错误');
				}
			);
		}
	}
</script>
